__turbopack_context__.v({
  "highlightPulse": "yYwV1W_highlightPulse",
  "input": "yYwV1W_input",
  "list": "yYwV1W_list",
  "partial": "yYwV1W_partial",
  "root": "yYwV1W_root",
  "title": "yYwV1W_title",
});
